import React from "react";
import { mainApiPath } from "api/constants";
import EventFeature from "components/Kiosk/Event/EventFeature";
import EventList from "components/Kiosk/Event/EventList";
import FilterSection from "components/shared/FilterSection";
import useFetch from "hooks/useFetch";
import useGaPageView from "hooks/useGaPageView";
import KioskLayout from "components/Layout/KioskLayout";
import { screenKeys, gaSettings } from "config/constants";
import { useSelector } from "react-redux";
import languages from "languages/languages";

const KioskEvent = (props) => {
  const [error, loading, data] = useFetch(mainApiPath.event);
  const langState = useSelector((state) => state.language.lang);
  const title = languages[langState]["Sự kiện nổi bật"];
  const titleButton = languages[langState]["Chỉ đường đến Sự kiện"];
  const noEvent = languages[langState]["Không có event"];

  const gaTitle = gaSettings.event.title;
  const gaLocation = gaSettings.event.location;
  useGaPageView({gaTitle, gaLocation});

  return (
    <KioskLayout
      error={error}
      goBack={screenKeys.kiosk}
      loading={loading}
      left={
        <>
          <EventFeature
            features={data ? data.features : null}
            loading={loading}
            title={title}
          />
          <FilterSection
            floors={data ? data.floors : null}
            search
            floorfilter
            loading={loading}
          />
        </>
      }
      right={
        <EventList
          events={data ? data.list : null}
          loading={loading}
          apiPath={mainApiPath.event}
          titleButton={titleButton}
          noEvent={noEvent}
        />
      }
    />
  );
};

export default KioskEvent;
